import React from 'react';

import {RadioGroup, Box, FormHelperText} from '@mui/material';
import {string} from 'prop-types';
import {Controller} from 'react-hook-form';

import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';
import RadioOption from '../field-components/RadioOption/RadioOption';

const RadioFieldRenderer = ({control, field, prefix, error, helperText}) => (
  <>
    <FieldLabel required={field.required}>{field.label}</FieldLabel>

    <Controller
      name={buildFieldName(field, prefix)}
      control={control}
      defaultValue={field.defaultValue || field.options?.[0]?.value}
      render={({field: rhfField}) => (
        <>
          <RadioGroup sx={{mb: 1.5, ml: 1.5}} row value={rhfField.value} onChange={e => rhfField.onChange(e.target.value)} aria-labelledby={field.label}>
            {field.options.map(opt => (
              <Box key={opt.value} ml={opt.marginLeft || 0}>
                <RadioOption value={opt.value} label={opt.label} field={rhfField} />
              </Box>
            ))}
          </RadioGroup>
          {helperText && error && (
            <FormHelperText error sx={{fontSize: 11, lineHeight: 1.1}}>
              {helperText}
            </FormHelperText>
          )}
        </>
      )}
    />
  </>
);

RadioFieldRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  prefix: string,
  error: string,
  helperText: string
};

export default RadioFieldRenderer;
